import React from 'react';
import PropTypes from 'prop-types';

import styles from './Step.scss';

const propTypes = {
    name: PropTypes.string,
};

function Step({ children, name }) {
    return (
        <div className={styles.step}>
            {name && <h4 className={styles.title}>{name}</h4>}
            {children}
        </div>
    );
}

Step.propTypes = propTypes;

export default Step;
